import { Component, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './header.html',
  styleUrl: './header.css'
})
export class HeaderComponent {
  isMobileMenuOpen = false;
  isServiciosSubmenuOpen = false;
  isDropdownOpen = false;
  isScrolled = false;
  private dropdownTimeout: any;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.isScrolled = window.scrollY > 10;
  }

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
    if (!this.isMobileMenuOpen) {
      this.isServiciosSubmenuOpen = false;
    }
    document.body.style.overflow = this.isMobileMenuOpen ? 'hidden' : 'auto';
  }

  closeMobileMenu() {
    this.isMobileMenuOpen = false;
    this.isServiciosSubmenuOpen = false;
    document.body.style.overflow = 'auto';
  }

  toggleServiciosSubmenu(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.isServiciosSubmenuOpen = !this.isServiciosSubmenuOpen;
  }

  closeServiciosSubmenu(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.isServiciosSubmenuOpen = false;
  }

  showDropdown() {
    if (this.dropdownTimeout) {
      clearTimeout(this.dropdownTimeout);
    }
    console.log('header: showDropdown');
    this.isDropdownOpen = true;
  }

  hideDropdown() {
    if (this.dropdownTimeout) {
      clearTimeout(this.dropdownTimeout);
    }
    this.dropdownTimeout = setTimeout(() => {
      console.log('header: hideDropdown');
      this.isDropdownOpen = false;
    }, 300);
  }

  // Click toggle in desktop (useful for touch-enabled laptops)
  toggleDropdownDesktop(event: Event) {
    if (window.innerWidth > 1000) {
      event.preventDefault();
      event.stopPropagation();
      this.isDropdownOpen = !this.isDropdownOpen;
      console.log('header: toggleDropdownDesktop ->', this.isDropdownOpen);
    }
  }
}
